// @flow
import { TiposSolicitantesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    tipoSolicitante: {},
    listaTiposSolicitantes: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type TiposSolicitantesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { tipoSolicitante?: {} | null, listaTiposSolicitantes?: [] | null, loading?: boolean, +value ?: boolean };

const TiposSolicitantes = (state: State = INIT_STATE, action: TiposSolicitantesAction): any => {
    // console.log(action);
    switch (action.type) {
        case TiposSolicitantesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TiposSolicitantesActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        tipoSolicitante: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposSolicitantesActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        listaTiposSolicitantes: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposSolicitantesActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS: {
                    return {
                        ...state,
                        listaTiposSolicitantes: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposSolicitantesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TiposSolicitantesActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        tipoSolicitante: {},
                        loading: false,
                    };
                }
                case TiposSolicitantesActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaTiposSolicitantes: [],
                        loading: false,
                    };
                }
                case TiposSolicitantesActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS: {
                    return {
                        ...state,
                        listaTiposSolicitantes: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposSolicitantesActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposSolicitantesActionTypes.GET_TIPO:
            return { ...state, error: false, loading: true };
        case TiposSolicitantesActionTypes.LIST_TIPOS:
            return { ...state, error: false, loading: true };
        case TiposSolicitantesActionTypes.ADD_TIPO:
            return { ...state, error: false, loading: true, formSubmited: true };
        case TiposSolicitantesActionTypes.UPDATE_TIPO:
            return { ...state, error: false, loading: true };
        case TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS:
            return { ...state, error: false, loading: true };
        case TiposSolicitantesActionTypes.DELETE_TIPO:
            return { ...state, error: false, loading: true };
        case TiposSolicitantesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                tipoSolicitante: {},
                listaTiposSolicitantes: [],
                formSubmited: false
            };
        case TiposSolicitantesActionTypes.RESET_SOFT:
            return {
                ...state,
                loading: false,
                error: false,
                formSubmited: false
            };
        case TiposSolicitantesActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default TiposSolicitantes;
